export function HamburgerIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 2H0V4H24V2Z" fill="white" />
      <path d="M24 11H0V13H24V11Z" fill="white" />
      <path d="M24 20H0V22H24V20Z" fill="white" />
    </svg>
  );
}
